import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import ReadOnlyRateCardContainer from './container';
import { messages } from './messages';
import style from './styles.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import {
  useVoidedFulfillmentsForFulfillmentPlan,
  useActiveFulfillmentIdsForFulfillmentPlan,
} from '../../../../../../hooks/entities/selectors/fulfillments';
import VoidedLabelExpander from '../../../../rate-card/voided/voided-label-expander';
import { OrderDetailsTabSection } from '../../../../tab-section/section';
import { FulfillmentDisplay } from '../../fulfillment-display';

/**
 * @typedef {object} RateCardReadOnlyFulfillmentsProps
 * @property {string} [className]
 * @property {string} fulfillmentPlanId
 * @property {boolean} [showFulfillmentDisplay]
 */

/**
 * @param {RateCardReadOnlyFulfillmentsProps} props
 * @returns {JSX.Element | null}
 */
const RateCardReadOnlyFulfillmentsComponent = ({ className, showFulfillmentDisplay = false, fulfillmentPlanId }) => {
  const activeFulfillmentIds = useActiveFulfillmentIdsForFulfillmentPlan(fulfillmentPlanId) || emptyArray;
  const voidedFulfillments = useVoidedFulfillmentsForFulfillmentPlan(fulfillmentPlanId) || emptyArray;

  if (!activeFulfillmentIds.length && !voidedFulfillments.length) {
    return null;
  }

  return (
    <div className={className}>
      {activeFulfillmentIds.length > 1 && (
        <OrderDetailsTabSection ariaLabelMessageDescriptor={messages.multipleActiveFulfillmentsSectionAriaLabel}>
          <BannerMessageV2 content={<FormattedMessage {...messages.multipleActiveFulfillments} />} status={BannerStatus.Info} />
        </OrderDetailsTabSection>
      )}
      {activeFulfillmentIds.map((fulfillmentId) => (
        <React.Fragment key={fulfillmentId}>
          <ReadOnlyRateCardContainer fulfillmentId={fulfillmentId} />
          {showFulfillmentDisplay ? <FulfillmentDisplay fulfillmentId={fulfillmentId} /> : null}
        </React.Fragment>
      ))}
      {activeFulfillmentIds.length === 0 && voidedFulfillments.length > 0 && (
        <OrderDetailsTabSection
          ariaLabelMessageDescriptor={messages.voidedFulfillmentSectionAriaLabel}
          className={style['voided-label-section']}
        >
          <VoidedLabelExpander voidedFulfillments={voidedFulfillments} />
        </OrderDetailsTabSection>
      )}
    </div>
  );
};

export const RateCardReadOnlyFulfillments = memo(RateCardReadOnlyFulfillmentsComponent);
